import { render } from "./MyReview.vue?vue&type=template&id=37cd30a5"
import script from "./MyReview.vue?vue&type=script&lang=js"
export * from "./MyReview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__